import Vue from "vue";
import VueRouter from "vue-router";
import * as middleware from "@/router/middleware";
import { GlobalRoutes } from "@core/routes";
import { MInitMiddleware } from "@core/routes/middleware";

Vue.use(VueRouter);

const routes = [
  {
    path: "/:accountId/dashboard",
    name: "dashboard",
    component: () =>
      import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard.vue"),
    meta: { requiresAuth: true, search: { name: "tickets" } },
  },

  {
    path: "/:accountId/contacts",
    name: "contact-list",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/contacts/Index.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/:accountId/contacts/create-new",
    name: "create-contact",
    component: () => import("@/views/contacts/CreateUpdate.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/:accountId/contacts/:id/edit",
    name: "edit-contact",
    component: () => import("@/views/contacts/CreateUpdate.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/:accountId/tags",
    name: "tags",
    component: () => import("@/views/tags/index.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/:accountId/tickets",
    name: "tickets",
    component: () => import("@/views/tickets/Index.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/:accountId/tickets/create-new",
    name: "new-ticket",
    component: () => import("@/views/tickets/CreateNew.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/:accountId/tickets/:id",
    name: "ticket-details",
    component: () => import("@/views/tickets/SingleTicket.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/:accountId/tickets-trash",
    name: "tickets-trash",
    component: () => import("@/views/tickets/Trash.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/:accountId/my-tickets",
    name: "my-tickets",
    component: () => import("@/views/tickets/Index.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/:accountId/high-priority-tickets",
    name: "high-priority-tickets",
    component: () => import("@/views/tickets/Index.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/:accountId/custom-view/:id",
    name: "custom-view",
    component: () => import("@/views/tickets/Index.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/:accountId/reports",
    name: "reports",
    component: () => import("@/views/Reports.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/:accountId/settings",
    name: "settings",
    component: () => import("@/views/settings/Index.vue"),
    meta: { requiresAuth: true, search: { name: "tickets" } },
  },
  {
    path: "/:accountId/settings/ticket-types",
    name: "ticket-type",
    component: () => import("@/views/settings/TicketType.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/:accountId/settings/groups",
    name: "groups",
    component: () => import("@/views/settings/Groups.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/:accountId/settings/service-hours",
    name: "service-hours",
    component: () => import("@/views/settings/service_hours/Index.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/:accountId/settings/service-hours/create-new",
    name: "new-service-hour",
    component: () => import("@/views/settings/service_hours/CreateUpdate.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/:accountId/settings/service-hours/:id",
    name: "view-service-hour",
    component: () => import("@/views/settings/service_hours/CreateUpdate.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/:accountId/settings/service-hours/:id/edit",
    name: "edit-service-hour",
    component: () => import("@/views/settings/service_hours/CreateUpdate.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/:accountId/settings/emails",
    name: "support-emails",
    component: () => import("@/views/settings/emails/Index.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/:accountId/settings/emails/new",
    name: "new-support-email",
    component: () => import("@/views/settings/emails/CreateUpdate.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/:accountId/settings/email/:id/edit",
    name: "edit-email",
    component: () => import("@/views/settings/emails/CreateUpdate.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/:accountId/settings/reply-templates",
    name: "reply-templates",
    component: () => import("@/views/settings/reply_templates/Index.vue"),
    meta: { requiresAuth: true },
  },

];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [...routes, ...GlobalRoutes],
});

/**
 * Middleware Before Every Route.
 */
router.beforeEach(middleware.devIdentiyTokenHandler);
router.beforeEach(middleware.isLoggedIn);
router.beforeEach(middleware.pageNotFound);

/**
 * Middleware Afer Every Route.
 */
router.afterEach(middleware.pageLoadHandler);

MInitMiddleware(router);

export default router;
